import { IId } from 'interfaces/common/common';

import { useQuery } from '@hooks/reactQuery';

import { getAssetVisibility } from '@api/assetVisibility';

import { extractQueryParams } from '@utils/common';

import { IAssetVisibility } from '@interfaces/assets/assetVisibility';

import { EUserRoles } from '@enums/common';

import { ASSET_VISIBILITY } from '@constants/queryKeys';

interface IUseQueryAssetVisibilityReturned {
	assetVisibility?: IAssetVisibility;
	isLoadingAssetVisibility: boolean;
}

export const useQueryAssetVisibility = ({ id }: IId): IUseQueryAssetVisibilityReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ASSET_VISIBILITY, { id }],
		allowedRoles: [
			EUserRoles.platformOwnerAdministrator,
			EUserRoles.assetOwnerOrganizationAdministrator,
		],
		queryFn: extractQueryParams(getAssetVisibility),
		refetchOnWindowFocus: false,
		enabled: [!!id],
	});

	return {
		assetVisibility: data,
		isLoadingAssetVisibility: isInitialLoading,
	};
};
